import { render, staticRenderFns } from "./Encontraras.vue?vue&type=template&id=996a9e0e&scoped=true&"
import script from "./Encontraras.vue?vue&type=script&lang=js&"
export * from "./Encontraras.vue?vue&type=script&lang=js&"
import style0 from "./Encontraras.vue?vue&type=style&index=0&id=996a9e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996a9e0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
